import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Home from './Home';
import ConfiguratorEpilab from './ConfiguratorEpilab';
import ConfiguratorAriane from './ConfiguratorAriane';
import RentabiliteAriane from './RentabiliteAriane';
import './App.css';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/configurateur-epilab" element={<ConfiguratorEpilab />} />
        <Route path="/configurateur-ariane" element={<ConfiguratorAriane />} />
        <Route path="/rentabilite-ariane" element={<RentabiliteAriane />} />
        {/* Adresse inconnue : retour à l'accueil plutôt qu'une page blanche */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Router>
  );
}

export default App;
